import FundsPage from '../pages/funds/FundsPage';
import UsersPage from '../pages/users/UsersPage';
import KYCPage from '../pages/kyc/KYCPage';
import TransactionPage from '../pages/transaction/TransactionPage';
import TransactionDetailPage from '../pages/transaction_details/TransactionDetailPage';
import DocumentVerification from '../pages/kyc_details/DocumentVerificationPage';
import FundManagerDetailPage from '../pages/fund_manager_details/FundManagerDetailPage';
import FundDetailPage from '../pages/funds_detail/FundDetailPage';
import FundInvestmentDetailPage from '../pages/fund_investment_details/FundInvestmentDetailPage';
import FundUserDrillDownPage from '../pages/fund_user_drill_down/FundUserDrillDown';
import UserInvestmentDetailPage from '../pages/user_details/UserInvestmentDetails';
import DashboardHome from '../pages/home/DashboardPage';
import CreateUserPage from '../pages/create_user/CreateUserPage';
import CreateFundManagerPage from '../pages/create_fund_manager/CreateFundManager';
import CreateFundPage from '../pages/create_fund/CreateFundPage';
import CreateAssignPage from '../pages/create_assign/CreateAssignPage';
import LoginPage from '../pages/login/LoginPage';
import SignUpPage from '../pages/signup/SignupPage';
import FundsManagerPage from '../pages/fund_manager/FundManagerPage';

// config/routes.js
export const ROLES = {
    ADMIN: 'ADMIN',
    FUND_MANAGER: 'FUND_MANAGER',
    CUSTOMER: 'CUSTOMER'
  };
  
  export const routes = [
    {
      path: '/login',
      element: LoginPage,
      protected: false,
      roles: [] // public route
    },
    {
      path: '/signup',
      element: SignUpPage,
      protected: false,
      roles: []
    },
    {
      path: '/',
      element: DashboardHome,
      protected: true,
      roles: [ROLES.ADMIN, ROLES.FUND_MANAGER, ROLES.CUSTOMER]
    },
    {
      path: '/funds',
      element: FundsPage,
      protected: true,
      roles: [ROLES.ADMIN, ROLES.FUND_MANAGER]
    },
    {
      path: '/fund-manager',
      element: FundsManagerPage,
      protected: true,
      roles: [ROLES.ADMIN]
    },
    {
      path: '/users',
      element: UsersPage,
      protected: true,
      roles: [ROLES.ADMIN]
    },
    {
        path: '/kyc',
        element: KYCPage,
        protected: true,
        roles: [ROLES.ADMIN]
    },
    {
        path: '/transaction',
        element: TransactionPage,
        protected: true,
        roles: [ROLES.ADMIN, ROLES.FUND_MANAGER]
    },
    {
        path: '/transaction-details/:id',
        element: TransactionDetailPage,
        protected: true,
        roles: [ROLES.ADMIN, ROLES.FUND_MANAGER]
    },
    {
        path: '/verification-details/:id',
        element: DocumentVerification,
        protected: true,
        roles: [ROLES.ADMIN]
    },
    {
        path: '/fund-manager-details/:id',
        element: FundManagerDetailPage,
        protected: true,
        roles: [ROLES.ADMIN]
    },
    {
        path: '/fund-details/:id',
        element: FundDetailPage,
        protected: true,
        roles: [ROLES.ADMIN, ROLES.FUND_MANAGER]
    },
    {
        path: '/fund-investment-details/:id',
        element: FundInvestmentDetailPage,
        protected: true,
        roles: [ROLES.ADMIN, ROLES.FUND_MANAGER]
    },
    {
        path: '/fund-user-drilldown/:id',
        element: FundUserDrillDownPage,
        protected: true,
        roles: [ROLES.ADMIN, ROLES.FUND_MANAGER]
    },
    {
        path: '/user-details/:id',
        element: UserInvestmentDetailPage,
        protected: true,
        roles: [ROLES.ADMIN]
    },
    {
        path: '/create-user',
        element: CreateUserPage,
        protected: true,
        roles: [ROLES.ADMIN]
    },
    {
        path: '/create-fund-manager',
        element: CreateFundManagerPage,
        protected: true,
        roles: [ROLES.ADMIN]
    },
    {
        path: '/create-fund',
        element: CreateFundPage,
        protected: true,
        roles: [ROLES.ADMIN]
    },
    {
        path: '/assign-user',
        element: CreateAssignPage,
        protected: true,
        roles: [ROLES.ADMIN]
    },
    // ... other routes with their respective role requirements
  ];
  